import { Capabilities } from 'src/types/capabilities';
import { useMeContext } from './use-context';

export const useCapabilities = (): Capabilities => useMeContext().capabilities;
